import { SpyneTrait } from 'spyne';
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';        //for HTML
import css from 'highlight.js/lib/languages/css';
import json from 'highlight.js/lib/languages/json';


//import 'highlight.js/styles/atom-one-dark.css'; // or any other; easy to replace later

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('css', css);
hljs.registerLanguage('json', json);

export class HighlightTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'hl$';
    super(context, traitPrefix);
  }

  static hl$HelloWorld() {
    return 'Hello World';
  }

  static hl$HighlightBlocks(props=this.props){


    const hlBlock = (block)=>{
      hljs.highlightElement(block);
      block.setAttribute('data-hljs', '1');
    };


    const blocks = props.el$('pre code:not([data-hljs])').els;
    blocks.forEach(hlBlock);





  }
}
